import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const NotFound = () => {
    const location = useLocation();

    // Cleaning the path just like your script did
    const cleanPath = location.pathname.replace('/rbxscript-scanner', '') || '/';

    return (
        <div style={styles.pageWrapper}>
            {/* Global Styles injected via JS for the pseudo-elements */}
            <style>
                {`
                body { background-color: #050505; margin: 0; padding: 0; overflow: hidden; }
                .scanline::after {
                    content: " ";
                    position: fixed;
                    top: 0; left: 0; bottom: 0; right: 0;
                    background: linear-gradient(rgba(18, 16, 16, 0) 50%, rgba(0, 0, 0, 0.25) 50%),
                                linear-gradient(90deg, rgba(255, 0, 0, 0.06), rgba(0, 255, 0, 0.02), rgba(0, 0, 255, 0.06));
                    background-size: 100% 4px, 3px 100%;
                    pointer-events: none;
                    z-index: 10;
                }
                .grid-bg::before {
                    content: '';
                    position: fixed;
                    inset: 0;
                    background-image: linear-gradient(rgba(255, 255, 255, 0.022) 1px, transparent 2px), 
                                      linear-gradient(90deg, rgba(255, 255, 255, 0.022) 1px, transparent 1px);
                    background-size: 56px 56px;
                    pointer-events: none;
                    z-index: -1;
                }
                @keyframes flicker {
                    0% { opacity: 0.95; }
                    5% { opacity: 0.85; }
                    10% { opacity: 0.95; }
                    100% { opacity: 1; }
                }
                `}
            </style>

            <div className="scanline grid-bg" style={styles.container}>
                <div style={styles.alertBox}>
                    <div style={styles.header}>
                        <span style={styles.iconWarning}>⚠</span>
                        <h1 style={styles.faultTitle}>System Failure</h1>
                    </div>

                    <div style={styles.dataStack}>
                        <div style={styles.entry}>
                            <span style={styles.label}>Fault Code</span>
                            <span style={styles.content}>PAGE_NOT_FOUND (404)</span>
                        </div>

                        <div style={styles.entry}>
                            <span style={styles.label}>Target Page</span>
                            <div style={styles.pathHighlight}>{cleanPath}</div>
                        </div>

                        <div style={styles.entry}>
                            <span style={styles.label}>Analysis</span>
                            <span style={{ ...styles.content, color: '#888888', fontSize: '16px' }}>
                                We're sorry! <br /><br />
                                The requested directory doesn't exist, has been purged, or has moved to another location. <br /><br />
                                Let's get you back home.
                            </span>
                        </div>
                    </div>
                </div>

                <div style={styles.rebootContainer}>
                    <Link to="/" style={styles.rebootBtn}>
                        Initialize System Reboot
                    </Link>
                </div>
            </div>
        </div>
    );
};

const styles = {
    pageWrapper: {
        height: '100vh',
        width: '100vw',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#050505',
        color: '#ffffff',
        fontFamily: "'Inter', -apple-system, sans-serif",
        position: 'relative',
    },
    container: {
        width: '90%',
        maxWidth: '600px',
        zIndex: 5,
        animation: 'flicker 0.2s infinite',
    },
    alertBox: {
        background: 'rgba(10, 0, 0, 0.9)',
        border: '2px solid #ff2e2e',
        borderRadius: '4px',
        boxShadow: '0 0 30px rgba(255, 46, 46, 0.2)',
        padding: '40px',
        position: 'relative',
        overflow: 'hidden',
    },
    header: {
        display: 'flex',
        alignItems: 'center',
        gap: '20px',
        marginBottom: '30px',
        borderBottom: '1px solid rgba(255, 46, 46, 0.15)',
        paddingBottom: '20px',
    },
    iconWarning: {
        color: '#ff2e2e',
        fontSize: '40px',
        fontWeight: '900',
    },
    faultTitle: {
        fontSize: '28px',
        fontWeight: '800',
        textTransform: 'uppercase',
        letterSpacing: '-1px',
        margin: 0,
        color: '#ff2e2e',
    },
    dataStack: {
        display: 'flex',
        flexDirection: 'column',
        gap: '25px',
    },
    entry: {
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
    },
    label: {
        fontFamily: 'monospace',
        fontSize: '12px',
        textTransform: 'uppercase',
        color: '#ff2e2e',
        opacity: 0.7,
    },
    content: {
        fontSize: '18px',
        lineHeight: '1.5',
    },
    pathHighlight: {
        fontFamily: 'monospace',
        background: 'rgba(255, 46, 46, 0.15)',
        padding: '6px 12px',
        borderRadius: '3px',
        border: '1px solid rgba(255, 46, 46, 0.3)',
        wordBreak: 'break-all',
        display: 'inline-block',
        marginTop: '5px',
        color: '#ffffff',
    },
    rebootContainer: {
        marginTop: '40px',
        textAlign: 'center',
    },
    rebootBtn: {
        background: '#ff2e2e',
        color: 'white',
        textDecoration: 'none',
        padding: '20px 40px',
        fontWeight: '800',
        textTransform: 'uppercase',
        letterSpacing: '2px',
        fontSize: '14px',
        borderRadius: '2px',
        transition: 'all 0.2s',
        display: 'inline-block',
        cursor: 'pointer',
    },
};

export default NotFound;